/* Built In Imports */
/* External Imports */
import { Center, VStack } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import MidContainer from '@Layout/MidContainer';
import LazyLoadImageComponent from '@components/UI/LazyLoadImageComponent';
import StructuredTextParser from '@components/Utility/ArticleParser/StructuredTextParser';
import config from '@config';

/* Services */
/**
 *
 * @param {Object} section
 * @returns
 */
const EoeQuote = ({ section, region, lang }) => {
  return (
    <Center bgColor="#592124">
      <MidContainer w={'480px'}>
        <VStack
          p={{ base: '44px 35px', md: '80px 10px' }}
          textAlign="center"
          alignItems="center"
          justifyContent="center"
        >
          <StructuredTextParser
            str={section.sectionContent[0]?.text}
            region={region}
            lang={lang}
            textAlign="center"
            fontWeight="400"
            fontSize="20px"
            lineHeight="34px"
            color="#FFFFFF"
            maxW={{ base: '250px', md: '660px' }}
            fontFamily="FedraSansStd-book-i"
            id="eoeQuote"
            mb={{ base: '21px', md: '23px' }}
            _before={{
              content: `url(${config.imgPath}/d/46272/1709625792-vector.png)`,
              paddingRight: '7px',
              width: '15px',
              height: '14px',
              position: 'relative',
              top: '-2px',
              display: { base: 'inline', md: 'none' },
            }}
            _after={{
              content: `url(${config.imgPath}/d/46272/1709625799-vector-1.png)`,
              paddingLeft: '7px',
              width: '15px',
              height: '14px',
              position: 'relative',
              bottom: '-2px',
              display: { base: 'inline', md: 'none' },
            }}
          />
          <LazyLoadImageComponent
            // w={{ base: 'unset', md: '108.78px' }}
            // h={{ base: 'unset', md: '51.99px' }}
            maxWidth="135px"
            src={section.sectionContent[1]?.image?.url}
            // m={{ base: '21px 0 0px', md: '23px 0 0px' }}
            display="block"
          />
        </VStack>
      </MidContainer>
    </Center>
  );
};

export default EoeQuote;
